import React, { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  List,
  ListItem,
  ListItemText,
  Dialog,
  Fab,
  Tooltip,
  Autocomplete,
  Alert,
} from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import './EmployeeOnboarding.css';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CircularProgress from '@mui/material/CircularProgress';

import {
  updateEmployeeOnBoardingRequest,
  addOrUpdateEmployeeOnboardingRequest,
} from '../../services/EmployeeService';
import EditCard from './EditCard';
import KeycloakService from '../../services/KeycloakService';
import { checkForJobType } from '../../services/EmployeeService';
import { updateEmployeeRole } from '../../admin/Services/MasterdataService';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';
import { getDesignations } from '../../admin/Services/MasterdataService';
import Notes from '../../components/Notes/Notes';
import '../../components/Notes/Notes.css';
import { getUserPhoto } from '../../services/UserService';
import { MINIO_PATH } from '../../url';

const cardStyle = {
  marginTop: '16px',
  position: 'relative',
  marginBottom: '8px',
  cursor: 'default',
  width: '100%',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
};

const cardHeaderStyle = {};

const cardContentStyle = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
};

const profileCardContentStyle = {
  width: '100%',
  display: 'block',
  paddingTop: '4px',
  paddingBottom: '12px',
  paddingLeft: '16px',
  paddingRight: '16px',
  boxSizing: 'border-box',
};

const profileListSx = {
  py: 0,
  '& .MuiListItem-root': {
    py: 0,
    px: 0,
  },
  '& .MuiListItemText-root': {
    margin: 0,
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  '& .MuiListItemText-secondary': {
    fontSize: '0.875rem',
  },
};

const employeeImageStyle = {
  width: '100px',
  height: '100px',
};

const listItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
};

const listItemTextStyle = {
  flex: '0 0 50%',
  maxWidth: '50%',
};

const boxStyles = {
  width: '28%',
  textAlign: 'center',
  height: '12rem',
  backgroundColor: 'white',
  position: 'absolute',
  top: '40%',
  left: '40%',
};

// Function to define the common styles for the buttons
const buttonStyles = {
  margin: '7%',
  color: 'white',
  width: '5%',
  height: '19%',
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
};

// Function to define the styles for the modal content
const modalContentStyles = {
  paddingTop: '10%',
};

// Function to handle the No button click and close the modal
const handleNoButtonClick = (setShowModal) => () => {
  setShowModal(false);
};

// Function to handle the Yes button click and perform the action
const handleYesButtonClick = (actionFunction, setShowModal) => () => {
  actionFunction();
  setShowModal(false);
};

// Function to render the modal content with specific details
const renderModalContent = (message, setShowModal, actionFunction) => {
  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <Box style={boxStyles}>
        <Typography sx={modalContentStyles}>{message}</Typography>
        <Button
          style={{ ...buttonStyles, backgroundColor: 'red' }}
          onClick={handleNoButtonClick(setShowModal)}
        >
          No
        </Button>
        <Button
          style={{ ...buttonStyles, backgroundColor: '#4d6cd9' }}
          onClick={handleYesButtonClick(actionFunction, setShowModal)}
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
};

const EmployeeCard = (props) => {
  const {
    isProfile,
    isAdmin,
    employee,
    EmployeeDetails,
    ShowErrorMessageDob,
    isHr,
    refreshPage,
    ShowErrorMessageDoj,
    ShowErrorMessageDoi,
    ShowErrorMessageOEmail,
    ShowErrorMessagePEmail,
    ShowErrorMessagePhoneNo,
    ShowErrorMessageEmployeeCode,
    UpdatedEmployeePhoto,
    ShowErrorMessage,
    Files,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
    designationNames,
    officeLocations,
    leaveGroups,
    reportingManagers,
  } = props;
  let employee1 = employee;
  const [openModal, setOpenModal] = React.useState(false);
  const [empDetail, setEmpDetail] = React.useState(employee);
  const [isEditable, setIsEditable] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [photoUrl, setPhotoUrl] = useState();

  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const handleOpen = () => {
    setOpenModal(true);
  };
  const handleEdit = () => {
    setEmpDetail(employee);
    setIsEditable(true);
  };
  const handleEditClose = () => {
    empDetail.employeeCode = employee.employeeCode;
    empDetail.jobType = employee.jobType;
    empDetail.designation = employee.designation;
    setIsEditable(false);
  };

  var updateEmpDetail;
  const handleSave = async () => {
    setShowModal1(true);
  };

  const confirmSave = async () => {
    setShowModal1(false);

    const toDateOnly = (value) =>
      value ? String(value).split('T')[0] : null;
    const originalEndDate = toDateOnly(employee?.internshipEndDate);
    const newEndDate = toDateOnly(empDetail?.internshipEndDate);
    const jobTypeChangedAwayFromInternship =
      employee?.jobType === 'INTERNSHIP' &&
      empDetail?.jobType &&
      empDetail.jobType !== 'INTERNSHIP';
    const endDateBeingSetForFirstTime = !originalEndDate && !!newEndDate;
    const endDateBeingChanged =
      !!originalEndDate && !!newEndDate && originalEndDate !== newEndDate;

    if (endDateBeingChanged) {
      dipatchNotification(
        'error',
        'Internship End Date can only be set once and cannot be updated.',
      );
      return;
    }
    if (jobTypeChangedAwayFromInternship && !originalEndDate && !newEndDate) {
      dipatchNotification(
        'error',
        'Please specify Internship End Date when changing Job Type from Internship.',
      );
      return;
    }
    if (
      endDateBeingSetForFirstTime &&
      (!empDetail?.jobType || empDetail.jobType === 'INTERNSHIP')
    ) {
      dipatchNotification(
        'error',
        'Please specify a new Job Type when setting Internship End Date.',
      );
      return;
    }

    // Explicit clear vs assign: selecting "Clear Leave Group" clears when a group was assigned.
    const clearedLeaveGroup =
      empDetail?.leaveGroupId == null && employee?.leaveGroupId != null;
    const payload = {
      ...empDetail,
      leaveGroupId: clearedLeaveGroup
        ? null
        : empDetail?.leaveGroupId != null
          ? empDetail.leaveGroupId
          : employee?.leaveGroupId,
      clearLeaveGroup: clearedLeaveGroup,
    };
    updateEmpDetail = await updateEmployeeRole(payload);

    if (updateEmpDetail.status !== 200) {
      dipatchNotification(updateEmpDetail.type, updateEmpDetail.message);
    }
    if (updateEmpDetail.status === 200) {
      employee.employeeCode = payload.employeeCode;
      employee.jobType = payload.jobType;
      employee.designation = payload.designation;
      employee.leaveGroupId = payload.clearLeaveGroup ? null : payload.leaveGroupId;
      employee.internshipEndDate =
        payload.internshipEndDate || employee.internshipEndDate;
      employee.reportingManagerId = payload.reportingManagerId;
      employee.reportingManagerDisplayName = payload.reportingManagerDisplayName;
      employee.reportingManagerEmployeeCode =
        payload.reportingManagerEmployeeCode;
      employee.reportingManagerEmail = payload.reportingManagerEmail;
      setEmpDetail({ ...payload, leaveGroupId: employee.leaveGroupId });
      setIsEditable(false);
      dipatchNotification(updateEmpDetail.type, updateEmpDetail.message);
    }
  };

  useEffect(() => {
    setIsEditable(false);
    setEmpDetail(employee);
  }, [refreshPage]);

  var eid;
  const handleJobTypeChange = async (event, value, id) => {
    const { ...newUserDetails } = empDetail;
    setEmpDetail({
      ...newUserDetails,
      jobType: value,
    });

    // Make sure to use 'await' when calling the async function
    const eid = await checkForJobType(value);
    if (value !== employee.jobType) {
      setEmpDetail({
        ...newUserDetails,
        jobType: value,
        employeeCode: eid.data.data,
      });
    }
    if (value == employee.jobType) {
      setEmpDetail({
        ...newUserDetails,
        jobType: value,
        employeeCode: employee.employeeCode,
      });
    }
    // Update the state directly with the new value for 'employeeCode'
  };

  const handleDesignationChange = async (event, value, id) => {
    const { ...newUserDetails } = empDetail;
    setEmpDetail({
      ...newUserDetails,
      designation: value,
    });
  };

  const handleLeaveGroupChange = (event) => {
    const value = event.target.value === '' ? null : event.target.value;
    setEmpDetail((prev) => ({
      ...prev,
      leaveGroupId: value,
    }));
  };

  const formatReportingManagerLabel = (manager) => {
    if (!manager) return '';
    return manager.displayName || '';
  };

  const handleReportingManagerChange = (_event, value) => {
    setEmpDetail((prev) => ({
      ...prev,
      reportingManagerId: value?.id || null,
      reportingManagerEmployeeCode: value?.employeeCode || null,
      reportingManagerEmail: value?.emailId || null,
      reportingManagerDisplayName: value?.displayName || null,
    }));
  };

  const selectedReportingManager =
    reportingManagers?.find(
      (manager) => manager.id === empDetail?.reportingManagerId,
    ) ||
    (empDetail?.reportingManagerId
      ? {
          id: empDetail.reportingManagerId,
          displayName: empDetail.reportingManagerDisplayName,
          employeeCode: empDetail.reportingManagerEmployeeCode,
          emailId: empDetail.reportingManagerEmail,
        }
      : null);

  const handleApprove = async () => {
    setLoading(true);
    employee1.status = 'APPROVED';
    const eid = await checkForJobType(employee1.jobType);
    employee1.employeeCode = eid.data.data;

    const employeeDetail = {
      ...employee1,
      approverId: KeycloakService.getUserDetail(),
    };
    const employeeListByStatus =
      await updateEmployeeOnBoardingRequest(employeeDetail);

    if (employeeListByStatus.status !== 200) {
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      setLoading(false);
      handleToggle(selectedStatus.value);
      return;
    }

    handleToggle(selectedStatus.value);
    setLoading(false);
  };

  const handleReject = async () => {
    setLoading1(true);
    employee1.status = 'REJECTED';
    const employeeDetail = {
      ...employee1,
      organizationEmailId: null,
      approverId: KeycloakService.getUserDetail(),
    };
    const employeeListByStatus =
      await updateEmployeeOnBoardingRequest(employeeDetail);

    if (employeeListByStatus.status !== 200) {
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      setLoading1(false);
      handleToggle(selectedStatus.value);
      return;
    }
    handleToggle(selectedStatus.value);
    setLoading1(false);
  };
  const handleCancel = () => {
    setShowModal(true);
  };
  const confirmClose = async () => {
    setShowModal(false);
    employee1.status = 'CANCELLED';
    employee1.organizationEmailId = null;
    const employeeListByStatus =
      await addOrUpdateEmployeeOnboardingRequest(employee1);
    handleToggle(selectedStatus.value);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const getPhotoUrl = async (photoPath) => {
    const response = await getUserPhoto(photoPath);
    if (response.status === 200) {
      const url = new URL(response.data);
      const remainingUrl = url.pathname + url.search;
      setPhotoUrl(`${MINIO_PATH}${remainingUrl}`);
    }
  };

  useEffect(() => {
    if (UpdatedEmployeePhoto) getPhotoUrl(UpdatedEmployeePhoto);
  }, [employee]);

  const fieldItemStyle = {
    paddingLeft: '2rem',
    paddingTop: '0rem',
  };

  const renderProfileField = (label, value) => (
    <List dense disablePadding sx={profileListSx}>
      <ListItem disableGutters style={listItemStyle}>
        <ListItemText primary={label} secondary={value || '-'} />
      </ListItem>
    </List>
  );

  const jobTypeDisplay =
    employee?.jobType == 'FULL_TIME'
      ? 'FULL-TIME'
      : employee?.jobType == 'PART_TIME'
        ? 'PART-TIME'
        : employee?.jobType;

  const leaveGroupDisplay =
    employee?.leaveGroupName ||
    leaveGroups?.find((group) => group.id === employee?.leaveGroupId)
      ?.groupName ||
    null;

  const reportingManagerDisplay = employee?.reportingManagerDisplayName
    ? formatReportingManagerLabel({
        displayName: employee.reportingManagerDisplayName,
        employeeCode: employee.reportingManagerEmployeeCode,
        emailId: employee.reportingManagerEmail,
      })
    : null;

  const toDisplayDate = (value) => {
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY') : null;
  };

  const internshipEndDateLocked = Boolean(employee?.internshipEndDate);
  const showInternshipEndDateField =
    employee?.jobType === 'INTERNSHIP' ||
    Boolean(employee?.internshipEndDate) ||
    Boolean(empDetail?.internshipEndDate);

  return (
    <>
      <Card
        style={{
          ...cardStyle,
          marginBottom: isProfile ? '8px' : cardStyle.marginBottom,
        }}
      >
        <CardHeader
          title={`${employee?.firstName} ${employee?.lastName || ''}`}
          style={cardHeaderStyle}
          sx={
            isProfile
              ? {
                  py: 1,
                  px: 2,
                  pr: isEditable ? '140px' : '80px',
                  '& .MuiCardHeader-title': { fontSize: '1.1rem' },
                }
              : undefined
          }
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            paddingLeft: isProfile ? 0 : '1.6rem',
          }}
        >
          {isProfile ? null : (
            <div>
              <CardMedia
                component="img"
                image={photoUrl}
                alt="Employee Photo"
                style={employeeImageStyle}
              />
            </div>
          )}
          <CardContent
            style={
              isProfile
                ? {
                    ...profileCardContentStyle,
                    paddingRight: isEditable ? '140px' : '80px',
                  }
                : {
                    ...cardContentStyle,
                    display: 'flex',
                    justifyContent: 'space-around',
                    paddingBottom: 0,
                  }
            }
          >
            {isProfile ? (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                  columnGap: 2,
                  rowGap: 2,
                  width: '100%',
                  alignItems: 'start',
                }}
              >
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable ? (
                    <TextField
                      size="small"
                      fullWidth
                      label="Email"
                      value={
                        employee?.emailId || employee?.organizationEmailId || ''
                      }
                      disabled
                    />
                  ) : (
                    renderProfileField(
                      'Email',
                      employee?.emailId || employee?.organizationEmailId,
                    )
                  )}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable ? (
                    <TextField
                      size="small"
                      fullWidth
                      label="Employee ID"
                      value={empDetail?.employeeCode ?? ''}
                      disabled
                    />
                  ) : (
                    renderProfileField('Employee ID', employee?.employeeCode)
                  )}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable ? (
                    <FormControl size="small" fullWidth>
                      <InputLabel id="designation-select-label">
                        Designation
                      </InputLabel>
                      <Select
                        labelId="designation-select-label"
                        id="designation-select"
                        label="Designation"
                        value={empDetail?.designation || ''}
                        onChange={(e) =>
                          handleDesignationChange(
                            e,
                            e.target.value,
                            e.target.id,
                          )
                        }
                      >
                        {designationNames?.map((designationName, index) => (
                          <MenuItem key={index} value={designationName}>
                            {designationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    renderProfileField('Designation', employee?.designation)
                  )}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable && employee?.jobType != 'FULL_TIME' ? (
                    <FormControl size="small" fullWidth>
                      <InputLabel id="job-type-select-label">
                        Job Type
                      </InputLabel>
                      <Select
                        labelId="job-type-select-label"
                        id="job-type-select"
                        label="Job Type"
                        value={empDetail?.jobType || ''}
                        onChange={(e) =>
                          handleJobTypeChange(e, e.target.value, e.target.id)
                        }
                      >
                        <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                        {employee.jobType == 'PART_TIME' ? (
                          <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                        ) : (
                          <MenuItem value="INTERNSHIP">INTERNSHIP</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  ) : isEditable ? (
                    <TextField
                      size="small"
                      fullWidth
                      label="Job Type"
                      value={jobTypeDisplay || ''}
                      disabled
                    />
                  ) : (
                    renderProfileField('Job Type', jobTypeDisplay)
                  )}
                </Box>
                {showInternshipEndDateField && (
                  <Box sx={{ minWidth: 0, width: '100%' }}>
                    {isEditable ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={
                            internshipEndDateLocked
                              ? 'Internship End Date (locked)'
                              : 'Internship End Date'
                          }
                          inputFormat="DD/MM/YYYY"
                          value={
                            empDetail?.internshipEndDate
                              ? dayjs(empDetail.internshipEndDate)
                              : null
                          }
                          disabled={internshipEndDateLocked}
                          onChange={(newValue) =>
                            setEmpDetail((prev) => ({
                              ...prev,
                              internshipEndDate:
                                newValue && dayjs(newValue).isValid()
                                  ? dayjs(newValue).format('YYYY-MM-DD')
                                  : null,
                            }))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              fullWidth
                              required={
                                employee?.jobType === 'INTERNSHIP' &&
                                empDetail?.jobType !== 'INTERNSHIP' &&
                                !internshipEndDateLocked
                              }
                              helperText={
                                internshipEndDateLocked
                                  ? 'Internship End Date can only be set once.'
                                  : employee?.jobType === 'INTERNSHIP'
                                    ? 'Required with a new Job Type when converting from Internship. Format: DD/MM/YYYY'
                                    : 'Format: DD/MM/YYYY'
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    ) : (
                      renderProfileField(
                        'Internship End Date',
                        toDisplayDate(employee?.internshipEndDate),
                      )
                    )}
                  </Box>
                )}
                {isEditable && employee?.jobType === 'INTERNSHIP' && (
                  <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
                    <Alert severity="warning" sx={{ py: 0.5 }}>
                      Changing Job Type requires Internship End Date. Setting
                      Internship End Date requires a new Job Type. Internship
                      End Date can only be set once.
                    </Alert>
                  </Box>
                )}
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable ? (
                    <FormControl size="small" fullWidth>
                      <InputLabel id="leave-group-select-label" shrink>
                        Leave Group
                      </InputLabel>
                      <Select
                        labelId="leave-group-select-label"
                        id="leave-group-select"
                        label="Leave Group"
                        notched
                        value={empDetail?.leaveGroupId ?? ''}
                        onChange={handleLeaveGroupChange}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) return 'None';
                          const group = leaveGroups?.find(
                            (g) => g.id === selected,
                          );
                          if (!group) return 'None';
                          return group.isActive === false
                            ? `${group.groupName} (inactive)`
                            : group.groupName;
                        }}
                      >
                        <MenuItem value="">
                          <em>Clear Leave Group</em>
                        </MenuItem>
                        {leaveGroups
                          ?.filter(
                            (group) =>
                              group?.isActive ||
                              group?.id === empDetail?.leaveGroupId,
                          )
                          .map((group) => (
                            <MenuItem key={group?.id} value={group?.id}>
                              {group?.groupName}
                              {group?.isActive === false ? ' (inactive)' : ''}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  ) : (
                    renderProfileField('Leave Group', leaveGroupDisplay)
                  )}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  {isEditable ? (
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={reportingManagers || []}
                      value={selectedReportingManager}
                      onChange={handleReportingManagerChange}
                      getOptionLabel={(option) =>
                        formatReportingManagerLabel(option)
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Reporting Manager"
                          placeholder="Search by name"
                        />
                      )}
                    />
                  ) : (
                    renderProfileField(
                      'Reporting Manager',
                      reportingManagerDisplay,
                    )
                  )}
                </Box>
              </Box>
            ) : (
            <Grid
              container
              spacing={2}
              style={{ padding: 0 }}
            >
              <Grid
                item
                xs={6}
                sm={6}
                md={3}
                style={{ paddingLeft: '2rem', paddingTop: '0rem' }}
              >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Employee ID"
                        secondary={
                          isEditable
                            ? empDetail?.employeeCode
                            : employee?.employeeCode
                        }
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
              </Grid>
              <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={fieldItemStyle}
                >
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Status"
                        secondary={employee?.status}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              {isEditable ? (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={fieldItemStyle}
                >
                  <InputLabel
                    htmlFor="designation-select"
                    style={{ background: '#fff', color: 'black' }}
                  >
                    Designation
                  </InputLabel>
                  <Select
                    sx={{ width: '100%' }}
                    labelId="designation-select"
                    id="designation-select"
                    value={empDetail?.designation}
                    onChange={(e) =>
                      handleDesignationChange(e, e.target.value, e.target.id)
                    }
                  >
                    {designationNames?.map((designationName, index) => (
                      <MenuItem key={index} value={designationName}>
                        {designationName}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={fieldItemStyle}
                >
                    <List>
                      <ListItem style={listItemStyle}>
                        <ListItemText
                          primary="Designation"
                          secondary={employee?.designation}
                          style={listItemTextStyle}
                        />
                      </ListItem>
                    </List>
                </Grid>
              )}
              {isEditable && employee?.jobType != 'FULL_TIME' ? (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={fieldItemStyle}
                >
                  <InputLabel
                    htmlFor="job-type-select"
                    style={{ background: '#fff', color: 'black' }}
                  >
                    Job Type
                  </InputLabel>
                  <Select
                    sx={{ width: '80%' }}
                    labelId="job-type-select"
                    id="job-type-select"
                    value={empDetail?.jobType}
                    onChange={(e) =>
                      handleJobTypeChange(e, e.target.value, e.target.id)
                    }
                    displayEmpty
                  >
                    <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                    {employee.jobType == 'PART_TIME' ? (
                      <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                    ) : (
                      <MenuItem value="INTERNSHIP">INTERNSHIP</MenuItem>
                    )}
                  </Select>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={fieldItemStyle}
                >
                    <List>
                      <ListItem style={listItemStyle}>
                        <ListItemText
                          primary="Job Type"
                          secondary={
                            employee?.jobType == 'FULL_TIME'
                              ? 'FULL-TIME'
                              : employee?.jobType == 'PART_TIME'
                                ? 'PART-TIME'
                                : employee?.jobType
                          }
                          style={listItemTextStyle}
                        />
                      </ListItem>
                    </List>
                </Grid>
              )}
              {isEditable &&
                employee?.jobType === 'INTERNSHIP' &&
                empDetail?.jobType &&
                empDetail.jobType !== 'INTERNSHIP' && (
                  <Grid item xs={6} sm={4} md={3} style={fieldItemStyle}>
                    <TextField
                      size="small"
                      sx={{ width: '80%' }}
                      required
                      label="Internship End Date"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={
                        empDetail?.internshipEndDate
                          ? String(empDetail.internshipEndDate).split('T')[0]
                          : ''
                      }
                      onChange={(e) =>
                        setEmpDetail((prev) => ({
                          ...prev,
                          internshipEndDate: e.target.value,
                        }))
                      }
                    />
                  </Grid>
                )}
            </Grid>
            )}
          </CardContent>
        </div>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            width: '100%',
            height: isProfile ? 0 : '10%',
            minHeight: 0,
            overflow: isProfile ? 'visible' : undefined,
          }}
        >
          {employee.status !== 'APPROVED' &&
            (isProfile ? (
              !isEditable ? (
                <>
                  {KeycloakService.hasRole(['admin']) && (
                    <Box className="styleForEmployeeCardNote">
                      <Notes employee={employee} />
                    </Box>
                  )}
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        Edit Details
                      </Typography>
                    }
                    placement="top"
                  >
                    <Fab
                      color="secondary"
                      size="small"
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '30px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleEdit();
                      }}
                    >
                      <EditIcon />
                    </Fab>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        Cancel{' '}
                      </Typography>
                    }
                    placement="top"
                  >
                    <Fab
                      color="secondary"
                      size="small"
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '100px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleEditClose();
                      }}
                    >
                      <CloseIcon />
                    </Fab>
                  </Tooltip>
                  <Tooltip
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        Save Details
                      </Typography>
                    }
                    placement="top"
                  >
                    <Fab
                      color="secondary"
                      size="small"
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '30px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleSave();
                      }}
                    >
                      <SaveIcon />
                    </Fab>
                  </Tooltip>
                </>
              )
            ) : (
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>
                    Edit Details
                  </Typography>
                }
                placement="top"
              >
                <Fab
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '30px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleOpen();
                  }}
                  disabled={loading || loading1}
                >
                  <EditIcon />
                </Fab>
              </Tooltip>
            ))}
          {isHr && employee.status !== 'APPROVED' ? (
            <Tooltip title="Cancel">
              <Fab
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '100px',
                  cursor: 'pointer',
                }}
                onClick={handleCancel}
              >
                <CloseIcon style={{ color: 'red', fontSize: '16px' }} />
              </Fab>
            </Tooltip>
          ) : (
            ''
          )}
          {loading ? (
            <Tooltip title="Approve">
              <Fab
                color="primary"
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '100px',
                  cursor: 'pointer',
                }}
              >
                <CircularProgress size={20} color="success" />
              </Fab>
            </Tooltip>
          ) : isAdmin ? (
            employee.status !== 'APPROVED' && (
              <Tooltip title="Approve">
                <Fab
                  color="primary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '100px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleApprove();
                  }}
                  disabled={loading || loading1}
                >
                  <ThumbUpIcon />
                </Fab>
              </Tooltip>
            )
          ) : (
            ''
          )}
          {loading1 ? (
            <Tooltip title="Reject">
              <Fab
                color="secondary"
                size="small"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '150px',
                  cursor: 'pointer',
                }}
              >
                <CircularProgress size={20} color="warning" />
              </Fab>
            </Tooltip>
          ) : isAdmin ? (
            employee.status !== 'APPROVED' &&
            employee.status !== 'REJECTED' && (
              <Tooltip title="Reject">
                <Fab
                  color="secondary"
                  size="small"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '150px',
                    cursor: 'pointer',
                  }}
                  onClick={handleReject}
                  disabled={loading || loading1}
                >
                  <ThumbDownIcon />
                </Fab>
              </Tooltip>
            )
          ) : (
            ''
          )}
        </div>
        {isProfile ? (
          ''
        ) : (
          <Accordion
            disableGutters
            elevation={0}
            sx={{
              width: '100%',
              '&:before': {
                display: 'none',
              },
            }}
          >
            <Grid
              className="leave-container pb-0 pt-0"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                height: '25px',
                alignItems: 'center',
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon />}
                sx={{ borderTop: 'none', cursor: 'pointer' }}
              />
            </Grid>

            <AccordionDetails>
              <Grid container spacing={13}>
                <Grid item xs={6} sm={6} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Organization Email"
                        secondary={employee?.organizationEmailId}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Phone Number"
                        secondary={employee?.phoneNumber}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Office Location"
                        secondary={employee?.locationName || '-'}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Personal Email"
                        secondary={employee?.personalEmailId}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary={
                          employee?.jobType === 'INTERNSHIP'
                            ? 'Date of Internship'
                            : 'Date of Joining'
                        }
                        secondary={
                          employee?.jobType === 'INTERNSHIP'
                            ? employee?.dateOfInternship?.split('T')[0]
                            : employee?.dateOfJoining?.split('T')[0]
                        }
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="Date of Birth"
                        secondary={employee?.dateOfBirth?.split('T')[0]}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                  <List>
                    <ListItem style={listItemStyle}>
                      <ListItemText
                        primary="CountryCode"
                        secondary={employee?.usageLocation}
                        style={listItemTextStyle}
                      />
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
      </Card>
      <Dialog open={openModal} fullWidth maxWidth="md" onClose={handleClose}>
        <Card variant="outlined" style={{ marginTop: '-1.2rem' }}>
          <EditCard
            designationNames={designationNames}
            officeLocations={officeLocations}
            leaveGroups={leaveGroups}
            reportingManagers={reportingManagers}
            isHr={isHr}
            isAdmin={isAdmin}
            handleToggle={handleToggle}
            selectedStatus={selectedStatus}
            allEmployeesDetails={allEmployeesDetails}
            updatedFiles={Files}
            employee={employee}
            updatedShowErrorMessage={ShowErrorMessage}
            UpdatedEmployeePhoto={photoUrl}
            handleClose={handleClose}
            updatedEmployeeDetails={EmployeeDetails}
            updatedShowErrorMessageDob={ShowErrorMessageDob}
            updatedShowErrorMessageDoj={ShowErrorMessageDoj}
            updatedShowErrorMessageDoi={ShowErrorMessageDoi}
            updatedShowErrorMessageOEmail={ShowErrorMessageOEmail}
            updatedShowErrorMessagePEmail={ShowErrorMessagePEmail}
            updatedShowErrorMessagePhoneNo={ShowErrorMessagePhoneNo}
            updatedShowErrorMessageEmployeeCode={ShowErrorMessageEmployeeCode}
          />
        </Card>
      </Dialog>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        {renderModalContent(
          'Do you want to Cancel this request?',
          setShowModal,
          confirmClose,
        )}
      </Modal>

      <Modal open={showModal1} onClose={() => setShowModal1(false)}>
        {renderModalContent(
          'Do you want to Save these details?',
          setShowModal1,
          confirmSave,
        )}
      </Modal>
    </>
  );
};

export default EmployeeCard;
